import BaseModel from './base';

export const DISABLED_SYSTEM_ASSIGN = {
  fio: 'fio',
};

/** У аттрибутов есть 3 состояния:
 * 1. Создан на цепочку (конкретный event) |не привязан !!!|
 * 2. Привязан на всё мероприятие [attach / { event_id: 1377, nomination_id: null }]
 * 3. Привязан на конкретную номинацию [attach / { event_id: 1377, nomination_id: 1968 }]
 *
 * @1 можно смотреть только через модель Event / getAttributes({ search[not_assign]: 1 })
 * @2 и @3 можно смотреть через менеджер этой модели
 */
export default class EventAttribute extends BaseModel {
  constructor(attribute, url) {
    super(attribute, url);
    this.title = attribute.title;
    this.type = attribute.type;
    this.is_required = attribute.is_required;
    this.is_many_options = attribute.is_many_options;

    this.event_id = attribute.event_id;
    this.nomination_id = attribute.nomination_id || null;

    this.assign = attribute.assign || []; // [{ event_id: 1377, nomination_id: 1958 }, ...]

    /** |На кастомные| String[], ex.: ['Option1', 'Option2']
     * |На системные| Object<{ assign: String, system_attribute: Boolean }>, ex.: { assign: 'snils', system_attribute: true }
     */
    this.options = attribute.options || null;

    this.document = attribute.document || null; // { id, url, original_name }

    this.user_value = attribute.user_value || null; // Ответ пользователя *если через форму запрашивать
  }

  get required() {
    return this.is_required;
  }

  get isSystem() {
    const { options } = this;
    if (typeof options !== 'object') return false;
    return !!this.options?.system_attribute;
  }

  get isSystemDisabled() {
    const { options, isSystem } = this;
    if (!isSystem) return false;
    return Object.values(DISABLED_SYSTEM_ASSIGN).includes(options?.assign || '');
  }

  get variants() {
    return (this.isSystem ? this.options?.variants : this.options) || [];
  }

  totalAssign(eventId, nominationId) {
    return (!this.event_id || this.event_id === eventId)
      && (this.nomination_id === nominationId || !this.nomination_id);
  }

  currentAssign(eventId, nominationId) {
    return (this.assign || []).find(({ event_id, nomination_id }) =>
      eventId === event_id && nomination_id === (nominationId || null),
    );
  }

  isAssigned(eventId, nominationId) {
    return !!this.currentAssign(eventId, nominationId);
  }

  isGlobal(eventId) {
    return !!this.currentAssign(eventId, null);
  }

  assignRequired(eventId, nominationId) {
    return this.currentAssign(eventId, nominationId)?.options?.required ?? this.is_required;
  }
}
